export const coreApiBase = process.env.REACT_APP_CORE_API_URL?.replace(/\/$/, '')
